module.exports = __webpack_public_path__ + "img/01.e5ca04dc.JPG";